/* funnls - cart gifts: EasyGift's free gifts live in one box at the top of
   UpCart's drawer, not as cart lines. Idempotent.

   Why (Ben, 2026-10-05): the free e-book and wipe showed up as full cart
   lines with a quantity, a bin and "$40.00 $0.00", so shoppers panicked
   that they were buying more than they were, and the upsell was pushed out
   of view. Now:
   - the gift lines are hidden and shown in a "+2 Free gifts added!" box above
     the products, closed by default, opening into one row per gift;
   - the header counts only what is paid for ("Cart • 1");
   - the footer says "2x Free gifts added  - $43.00" in green instead of the
     "Discounts" row with a tag per gift (any other discount keeps its own
     row, without the gift tags);
   - Bubblehouse's "Log in to redeem points and gifts" reads "collect".

   A gift line is one EasyGift added: it carries the _Gifted property. UpCart
   renders in a shadow root with React; this never replaces UpCart's nodes,
   only hides them (a stylesheet keyed by line key), edits their text in
   place and adds its own box, and re-applies whenever UpCart re-renders. */
(function () {
  if (window.__funnlsCartGifts) return;
  window.__funnlsCartGifts = true;

  var GIFT_PROP = '_Gifted';
  var GREEN = '#2e7d32';
  // How each gift reads in the box; anything else falls back to its title.
  var GIFTS = {
    'sexual-wellness-guide-free': { name: 'Sexual Wellness Guide', short: 'Wellness guide', note: 'E-book, sent by email' },
    'vanilla-freebie': { name: 'Collagen Wipe', short: 'collagen wipe', note: 'Ships in your box' },
    'vanilla-wipes-free-gift': { name: 'Vanilla Wipes', short: 'vanilla wipes', note: 'Ships in your box' },
  };

  var cart = null;
  var open = false;
  var root = null;
  var sheet = null;
  var styleEl = null;
  var box = null;
  var giftRow = null;
  var labelText = null;
  var lastFetch = 0;
  var queued = false;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function titleCase(s) { return String(s).toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }

  // The gifts are only for orders with a real product (Ben, 2026-10-09:
  // shoppers kept buying the $3 wipe on its own). A gift product (or anything
  // priced $0) put in the cart by hand - without EasyGift's _Gifted - is taken
  // out at once. EasyGift's own gifts with no real product beside them are
  // taken out only if that is still true a few seconds later: EasyGift adds
  // its gifts a moment BEFORE the product it rewards lands in the cart, so a
  // cart can briefly hold only gifts (2026-10-09: removing them at once cost
  // live orders their gifts). EasyGift itself removes them when the product
  // goes; this is the backup.
  var GIFT_HANDLES = Object.keys(GIFTS);
  var guarding = false;
  var recheck = null;
  var LONE_GIFT_WAIT = 6000;
  // A gift product, or anything priced $0 (e.g. the $0 "Vanilla Wipes - Free Gift" pack).
  function isGiftProduct(l) { return GIFT_HANDLES.indexOf(l.handle) > -1 || l.original_price === 0; }
  function isGifted(l) { return !!(l.properties && l.properties[GIFT_PROP]); }
  function hasPaid(c) { return c.items.some(function (l) { return !isGiftProduct(l) && !isGifted(l); }); }

  function removeLines(c, lines) {
    var updates = {};
    lines.forEach(function (l) { updates[l.key] = 0; });
    guarding = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) { return r.json(); })
      .then(function (next) {
        guarding = false;
        try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
        // The theme's own /cart page is drawn by the server: show the cleaned cart.
        if (/^\/cart\/?$/.test(location.pathname)) location.reload();
        return next && next.items ? next : c;
      })
      .catch(function () { guarding = false; return c; });
  }

  function guard(c) {
    if (!c || !c.items || guarding) return Promise.resolve(c);
    var byHand = c.items.filter(function (l) { return isGiftProduct(l) && !isGifted(l); });
    if (byHand.length) return removeLines(c, byHand);
    var lone = !hasPaid(c) && c.items.some(function (l) { return isGiftProduct(l) || isGifted(l); });
    if (lone && !recheck) {
      recheck = setTimeout(function () {
        recheck = null;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (now) {
            if (!now || !now.items || hasPaid(now)) return;
            var gifts = now.items.filter(function (l) { return isGiftProduct(l) || isGifted(l); });
            if (gifts.length) return removeLines(now, gifts).then(function (next) { cart = next; schedule(); });
          })
          .catch(function () {});
      }, LONE_GIFT_WAIT);
    }
    return Promise.resolve(c);
  }

  function getCart() {
    lastFetch = Date.now();
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(guard)
      .then(function (c) { cart = c; schedule(); })
      .catch(function () {});
  }

  function giftInfo() {
    var lines = (cart && cart.items || []).filter(function (l) { return l.properties && l.properties[GIFT_PROP]; });
    var count = 0, value = 0, titles = {};
    lines.forEach(function (l) {
      count += l.quantity;
      value += Math.max((l.original_line_price || 0) - (l.final_line_price || 0), 0);
      (l.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.title) titles[a.discount_application.title.toUpperCase()] = true;
      });
      (l.discounts || []).forEach(function (d) { if (d.title) titles[d.title.toUpperCase()] = true; });
    });
    return { lines: lines, count: count, value: value, titles: titles };
  }

  function describe(line) {
    var g = GIFTS[line.handle] || {};
    var name = g.name || titleCase(line.product_title);
    return { name: name, short: g.short || name.toLowerCase(), note: g.note || '' };
  }

  var CSS = [
    '.fg{margin:0 20px 8px;background:#f4ece4;border-radius:12px;color:#111;font-family:inherit}',
    '.fg-head{width:100%;min-height:60px;border:0;background:none;padding:12px 14px;display:flex;align-items:center;gap:12px;font:inherit;text-align:left;color:inherit;cursor:pointer;border-radius:12px}',
      // UpCart moves focus into the drawer when it opens; a soft inset ring, not a hard outline.
    '.fg-head:focus{outline:none}',
    '.fg-head:focus-visible{box-shadow:inset 0 0 0 2px rgba(74,59,58,.35)}',
    '.fg-thumbs{display:flex;flex-shrink:0}',
    '.fg-thumbs img{width:32px;height:42px;object-fit:cover;border-radius:4px;border:2px solid #f4ece4;background:#fff}',
    '.fg-thumbs img+img{margin-left:-10px}',
    '.fg-icon{flex-shrink:0;display:flex}',
    '.fg-text{flex:1;min-width:0}',
    '.fg-title{display:block;font-size:14px;font-weight:700;line-height:1.3;color:' + GREEN + '}',
    '.fg-sub{display:block;font-size:12px;color:#5f534c;line-height:1.35}',
    '.fg-nowrap{white-space:nowrap}',
    '.fg-free{display:flex;align-items:center;gap:6px;flex-shrink:0;color:' + GREEN + ';font-size:12px;font-weight:700;letter-spacing:.4px}',
    '.fg-free svg{transition:transform .2s ease}',
    '.fg[data-open] .fg-free svg{transform:rotate(180deg)}',
    '.fg-list{margin:0 14px;padding:12px 0 14px;border-top:1px solid #e6d9cd;display:flex;flex-direction:column;gap:12px}',
    '.fg-item{display:flex;align-items:center;gap:12px}',
    '.fg-item img{width:38px;height:50px;object-fit:cover;border-radius:4px;flex-shrink:0;background:#fff}',
    '.fg-item-text{flex:1;min-width:0}',
    '.fg-item-name{font-size:14px;font-weight:600;line-height:1.3}',
    '.fg-item-note{font-size:12px;color:#6b6b6b;line-height:1.35}',
    '.fg-item-free{font-size:12px;font-weight:700;color:' + GREEN + ';letter-spacing:.4px}',
    '.fg-row{display:flex;justify-content:space-between;align-items:center;gap:10px;margin-bottom:8px}',
    '.fg-row-amount{color:' + GREEN + ';font-weight:600}',
  ].join('\n');

  function setCss(text) {
    if (sheet) { try { sheet.replaceSync(text); return; } catch (e) {} }
    if (styleEl && styleEl.textContent !== text) styleEl.textContent = text;
  }

  function ensureStyles() {
    if (sheet || styleEl) return;
    try {
      if ('adoptedStyleSheets' in root && typeof CSSStyleSheet === 'function') {
        sheet = new CSSStyleSheet();
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
        return;
      }
    } catch (e) { sheet = null; }
    styleEl = document.createElement('style');
    root.appendChild(styleEl);
  }

  var GIFT_ICON = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#4a3b3a" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="7" width="15" height="4" rx="1"></rect><path d="M4 11v6.5h12V11M10 7v10.5M10 7C8.5 4 5.5 3.5 5.5 5.5S9 7 10 7zM10 7c1.5-3 4.5-3.5 4.5-1.5S11 7 10 7z"></path></svg>';
  var CHEVRON = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" stroke="' + GREEN + '" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M1 1.5l5 5 5-5"></path></svg>';

  function boxHtml(info) {
    var d = info.lines.map(describe);
    var n = info.count;
    var shorts = d.map(function (x) { return x.short; });
    var list = shorts.length > 1 ? shorts.slice(0, -1).join(', ') + ' + ' + shorts[shorts.length - 1] : shorts[0];
    list = list.charAt(0).toUpperCase() + list.slice(1);
    var value = '$' + Math.round(info.value / 100) + ' value';
    var head = '<button class="fg-head" type="button" aria-expanded="' + open + '">' +
      (open ? '<span class="fg-icon">' + GIFT_ICON + '</span>'
            : '<span class="fg-thumbs">' + info.lines.slice(0, 3).map(function (l) { return '<img src="' + esc(img(l.image, 96)) + '" alt="">'; }).join('') + '</span>') +
      '<span class="fg-text"><span class="fg-title">+' + n + ' Free gift' + (n === 1 ? '' : 's') + ' added!</span>' +
      '<span class="fg-sub">' + (open ? '' : esc(list) + ' · ') + '<span class="fg-nowrap">' + esc(value) + '</span></span></span>' +
      '<span class="fg-free">FREE' + CHEVRON + '</span></button>';
    var rows = open ? '<div class="fg-list">' + info.lines.map(function (l, i) {
      return '<div class="fg-item"><img src="' + esc(img(l.image, 120)) + '" alt="">' +
        '<div class="fg-item-text"><div class="fg-item-name">' + esc(d[i].name) + (l.quantity > 1 ? ' ×' + l.quantity : '') + '</div>' +
        (d[i].note ? '<div class="fg-item-note">' + esc(d[i].note) + '</div>' : '') + '</div>' +
        '<span class="fg-item-free">FREE</span></div>';
    }).join('') + '</div>' : '';
    return head + rows;
  }

  // Change a React-owned element's text by editing its text node in place,
  // so React keeps its reference and later updates still land.
  function setText(el, text) {
    if (!el) return;
    var node = null;
    for (var c = el.firstChild; c; c = c.nextSibling) if (c.nodeType === 3) { node = c; break; }
    if (!node) { if (el.textContent !== text) el.textContent = text; return; }
    if (node.nodeValue !== text) node.nodeValue = text;
    for (var o = node.nextSibling; o; o = o.nextSibling) if (o.nodeType === 3 && o.nodeValue) o.nodeValue = '';
  }

  function header(info) {
    var h = root.querySelector('.upcart-header-text');
    if (!h || !cart) return;
    var paid = Math.max(cart.item_count - info.count, 0);
    var txt = h.textContent;
    if (!/\d/.test(txt)) return;
    var next = txt.replace(/\d+(?!.*\d)/, String(paid));
    if (next !== txt) setText(h, next);
    var aria = h.getAttribute('aria-label');
    if (aria && /\d/.test(aria)) {
      var na = aria.replace(/\d+(?!.*\d)/, String(paid));
      if (na !== aria) h.setAttribute('aria-label', na);
    }
  }

  function footer(info) {
    var row = root.querySelector('.upcart-savings-row');
    var label = row && row.querySelector('.styles_Footer__savingsCodes__ > span');
    var amount = row && row.querySelector('.upcart-savings-amount');
    if (row && label && labelText === null) labelText = label.textContent;
    if (!row || !label || !amount) { if (giftRow && giftRow.parentNode) giftRow.parentNode.removeChild(giftRow); return; }
    var giftLabel = info.count + 'x Free gift' + (info.count === 1 ? '' : 's') + ' added';
    var other = Math.max((cart.total_discount || 0) - info.value, 0);
    row.querySelectorAll('.upcart-discount-code-badge').forEach(function (b) {
      var t = (b.textContent || '').trim().toUpperCase();
      var hide = info.count > 0 && !!info.titles[t];
      var want = hide ? 'none' : '';
      if (b.style.display !== want) b.style.display = want;
    });
    if (!info.count) {
      setText(label, labelText || 'Discounts');
      if (amount.style.color) amount.style.color = '';
      if (giftRow && giftRow.parentNode) giftRow.parentNode.removeChild(giftRow);
      return;
    }
    if (other <= 0) {
      // Only gifts: UpCart's row becomes the gifts row.
      setText(label, giftLabel);
      setText(amount, '- ' + money(info.value));
      if (amount.style.color !== 'rgb(46, 125, 50)') amount.style.color = GREEN;
      if (amount.style.fontWeight !== '600') amount.style.fontWeight = '600';
      if (giftRow && giftRow.parentNode) giftRow.parentNode.removeChild(giftRow);
      return;
    }
    // Gifts and another discount: our gifts row above UpCart's, which keeps the rest.
    setText(label, labelText || 'Discounts');
    setText(amount, '- ' + money(other));
    if (amount.style.color) amount.style.color = '';
    if (!giftRow) { giftRow = document.createElement('div'); giftRow.className = 'fg-row'; }
    var html = '<span>' + esc(giftLabel) + '</span><span class="fg-row-amount">- ' + money(info.value) + '</span>';
    if (giftRow.innerHTML !== html) giftRow.innerHTML = html;
    if (giftRow.nextSibling !== row || giftRow.parentNode !== row.parentNode) row.parentNode.insertBefore(giftRow, row);
  }

  // Bubblehouse's loyalty line sits in UpCart's footer in its own shadow root.
  function loyalty() {
    var panel = root.querySelector('bubblehouse-redeem-panel');
    var sr = panel && panel.shadowRoot;
    if (!sr) return;
    var walker = document.createTreeWalker(sr, NodeFilter.SHOW_TEXT);
    for (var n = walker.nextNode(); n; n = walker.nextNode()) {
      if (/redeem points and gifts/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/redeem points and gifts/i, 'collect points and gifts');
    }
  }

  function apply() {
    queued = false;
    if (!root || !cart) return;
    ensureStyles();
    var info = giftInfo();

    // A line UpCart shows that this cart copy doesn't know: re-read the cart.
    var known = {};
    cart.items.forEach(function (l) { known[l.key] = true; });
    var stale = [].some.call(root.querySelectorAll('.upcart-product-item[id]'), function (el) { return !known[el.id]; });
    if (stale && Date.now() - lastFetch > 1500) getCart();

    setCss(CSS + '\n' + info.lines.map(function (l) {
      return '.upcart-product-item[id="' + String(l.key).replace(/["\\]/g, '') + '"]{display:none!important}';
    }).join('\n'));

    var section = root.querySelector('.upcart-products-section');
    if (!info.count || !section) {
      if (box && box.parentNode) box.parentNode.removeChild(box);
    } else {
      if (!box) {
        box = document.createElement('div');
        box.className = 'fg';
        box.addEventListener('click', function (ev) {
          if (!ev.target.closest || !ev.target.closest('.fg-head')) return;
          open = !open;
          schedule();
        });
      }
      var html = boxHtml(info);
      if (box.__html !== html) { box.innerHTML = html; box.__html = html; }
      if (open) box.setAttribute('data-open', ''); else box.removeAttribute('data-open');
      if (box.parentNode !== section.parentNode || box.nextSibling !== section) section.parentNode.insertBefore(box, section);
      // Line the box up with UpCart's product rows (20px on phones, 30px on desktop).
      var first = section.querySelector('.upcart-product-item');
      var pad = first ? parseFloat(getComputedStyle(first).paddingLeft) : 0;
      var margin = '0 ' + (pad >= 12 ? pad : 20) + 'px 8px';
      if (box.style.margin !== margin) box.style.margin = margin;
    }

    header(info);
    footer(info);
    loyalty();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(apply);
  }

  function attach() {
    var r = window.upcartDocumentOrShadowRoot;
    if (typeof r === 'function') { try { r = r(); } catch (e) { r = null; } }
    if (!r || typeof r.querySelector !== 'function' || typeof window.upcartSubscribeCartUpdated !== 'function') return false;
    root = r;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
    window.upcartSubscribeCartUpdated(function () { getCart(); });
    if (typeof window.upcartSubscribeCartLoaded === 'function') window.upcartSubscribeCartLoaded(function () { getCart(); });
    if (typeof window.upcartSubscribeCartOpened === 'function') window.upcartSubscribeCartOpened(function () { open = false; getCart(); });
    document.addEventListener('funnls:cart-upgraded', function () { getCart(); });
    getCart();
    // Bubblehouse fills its panel after UpCart renders.
    [800, 2000, 4000].forEach(function (t) { setTimeout(loyalty, t); });
    return true;
  }

  // Wait for UpCart however long it takes (slow phones: 6-41s).
  // Check the cart on every page, with or without UpCart.
  fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(guard).catch(function () {});

  var tries = 0;
  (function wait() {
    if (attach()) return;
    setTimeout(wait, ++tries < 60 ? 250 : 1000);
  })();
})();
